import { services } from "../data/services";
import { sectors } from "../data/sectors";

// EN first segment -> AZ first segment
export const SEGMENTS = {
  services: "xidmetler",
  work: "case-studies",
  insights: "baxislar",
  about: "haqqimizda",
  contact: "elaqe",
  sectors: "saheler",
};
const AZ_TO_EN = Object.fromEntries(Object.entries(SEGMENTS).map(([en, az]) => [az, en]));
export const AZ_HOME = "/az";

const slugTables = {
  services: services.map((s) => [s.slug, s.azSlug]),
  sectors: sectors.map((s) => [s.slug, s.azSlug]),
};

const mapSlug = (section, slug, toLang) => {
  const table = slugTables[section];
  if (!table) return slug;
  const pair = table.find(([en, az]) => (toLang === "az" ? en === slug : az === slug));
  return pair ? (toLang === "az" ? pair[1] : pair[0]) : slug;
};

export const langFromPath = (pathname) => {
  if (pathname === AZ_HOME || pathname.startsWith(`${AZ_HOME}/`)) return "az";
  if (pathname === "/") return "en";
  const first = pathname.split("/")[1] || "";
  if (first in AZ_TO_EN) return "az";
  if (first in SEGMENTS) return "en";
  return null;
};

// Convert any path (EN or AZ form) to the requested language, keeping query/hash.
export const localizePath = (path, lang) => {
  const suffixAt = path.search(/[?#]/);
  const pathname = suffixAt < 0 ? path : path.slice(0, suffixAt);
  const rest = suffixAt < 0 ? "" : path.slice(suffixAt);
  if (pathname === "/" || pathname === AZ_HOME) return (lang === "az" ? AZ_HOME : "/") + rest;
  const parts = pathname.split("/").filter(Boolean);
  const first = parts[0];
  const enSection = first in SEGMENTS ? first : AZ_TO_EN[first];
  if (!enSection) return pathname + rest;
  const section = lang === "az" ? SEGMENTS[enSection] : enSection;
  const slug = parts[1] ? mapSlug(enSection, parts[1], lang) : null;
  return "/" + [section, slug, ...parts.slice(2)].filter(Boolean).join("/") + rest;
};
